import { bootstrapEndpoint } from '@springtree/eva-sdk-core-service';
import storage from './storage.js';
const getEvaEndpoint = async (uri) => {
    const evaEndpoint = await bootstrapEndpoint({ storage, uri });
    return evaEndpoint;
};
export default getEvaEndpoint;
//# sourceMappingURL=get-eva-endpoint.js.map